@let visionTradable = visionTradable$ | async;
<div class="banner-text-container">
	@let visionTopUp = bannerState === bannerStateEnum.OPTEDININSUFFICIENTFUNDS && !isVision;
	<span class="banner-title">
		{{
			(visionTopUp ? "vision_banner_success_insufficent_funds_title" : "vision_banner_success_opt_in_title")
				| translate: [visionTradable?.getSymbol()]
		}}</span
	>
	<span class="banner-description">
		{{
			(visionTopUp ? ("vision_banner_success_insufficent_funds_subtitle" | translate: [visionTradable?.getSymbol()]) : ("vision_banner_success_opt_in_subtitle" | translate: [visionTradable?.getSymbol(), feeAmount | percent]))
		}}
	</span>
</div>
<img class="vision-icon" [src]="'/assets/images/vision-logo.svg'" [alt]="'alt-icon' | translate" />
